import { render, staticRenderFns } from "./viewClaimItem.vue?vue&type=template&id=485d8048&"
import script from "./viewClaimItem.vue?vue&type=script&lang=js&"
export * from "./viewClaimItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VForm,VRow,VSelect,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485d8048')) {
      api.createRecord('485d8048', component.options)
    } else {
      api.reload('485d8048', component.options)
    }
    module.hot.accept("./viewClaimItem.vue?vue&type=template&id=485d8048&", function () {
      api.rerender('485d8048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/Ess/Claim/ClaimApplication/components/viewClaimItem.vue"
export default component.exports